export default __webpack_public_path__ + "static/media/pause-btn.5786db8b.svg";